/*
 * fs-bfcm-popup.js — the Black Month popup (sections/fs-bfcm-popup.liquid).
 * Shows the phase's prices, opens once per phase after a delay, steps
 * aside for any other open dialog, and hands the bundle button to the early-
 * access gate before 20 Nov (fs-bfcm-bar.js).
 */
(function () {
  'use strict';

  var pop = document.querySelector('[data-fs-bfpop]');
  var bfcm = window.FsBfcm;
  if (!pop || !bfcm || typeof pop.showModal !== 'function') return;

  var offer = bfcm.offer();
  if (!offer) return; /* soon / over: never shown */

  pop.querySelectorAll('[data-fs-bfpop-phase]').forEach(function (el) {
    el.hidden = el.getAttribute('data-fs-bfpop-phase') !== offer.phase;
  });
  pop.querySelectorAll('[data-fs-bfpop-pct]').forEach(function (el) { el.textContent = offer.pct; });

  /* ONCE PER PHASE, not once a day (user, 2026-10-29: "visible once, not every
     time we go on a new page"): once between 4 and 19 Nov, once more from 20 Nov
     when the prices drop. A preview counts per tab (sessionStorage), so a
     reviewer sees it once and can see it again in a new tab. */
  var KEY = 'fs-bfpop-seen:' + offer.phase;
  var store = null;
  try { store = bfcm.previewing ? window.sessionStorage : window.localStorage; } catch (e) { store = null; }
  try { if (store && store.getItem(KEY)) return; } catch (e) {}

  function close() {
    if (pop.open) pop.close();
  }
  pop.querySelector('[data-fs-bfpop-close]').addEventListener('click', close);
  /* A click on the backdrop lands on the dialog element itself. */
  pop.addEventListener('click', function (e) { if (e.target === pop) close(); });

  /* Before 20 Nov the bundle is early access by email: the button opens the
     bar's gate. If that gate is not on the page, it stays a link. */
  pop.querySelector('[data-fs-bfpop-bundle]').addEventListener('click', function (e) {
    if (offer.phase !== 'pre' || !bfcm.openGate) return;
    close();
    if (bfcm.openGate()) e.preventDefault();
  });

  function show() {
    if (document.querySelector('dialog[open]')) return; /* never over another dialog */
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) return; /* nor over the bag */
    try { if (store) store.setItem(KEY, '1'); } catch (e) {}
    pop.showModal();
  }

  var delay = bfcm.previewing ? 1 : (+pop.getAttribute('data-delay') || 8);
  window.setTimeout(show, delay * 1000);
})();
